<template>
    <div class="tab-content-wrap">

        <edit-switch :tab="selectedTab" :edit="editEnabled" :initialCondition="selectedTab == 0" v-on:toggleEdit="handleToggleEdit" />
        <div class="tab-content" style="min-height: 400px; padding-bottom: 20px!important;">
            <div class="item-content">
                <div class="access-sg text clearfix">
                    <div>
                        <div class="row">
                            <div class="col-12">

                                <div class="title text-dark-blue mb-2">
                                    Course information
                                </div>

                                <div class="d-flex justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <input v-if="editEnabled" class="ml-2" type="checkbox" v-model="course.enabled" />
                                        <h4 v-else class="text-uppercase">{{course.enabled}}</h4>
                                        <label class="ml-2 mt-1">Enabled</label>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <input v-if="editEnabled" class="ml-2" type="checkbox" v-model="course.isFacilitated" />
                                        <h4 v-else class="text-uppercase">{{course.isFacilitated ? "Yes" : "No"}}</h4>
                                        <label class="ml-2 mt-1">Is Facilitated</label>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <input v-if="editEnabled" class="ml-2" type="checkbox" v-model="course.promoted" />
                                        <h4 v-else class="text-uppercase">{{course.promoted ? "Enabled" : "Disabled"}}</h4>
                                        <label class="ml-2 mt-1">Feature on Home Page</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <label>Category</label>
                                <input v-if="editEnabled" v-model="course.category" type="text" placeholder="Enter category (Legal, Technical, etc) ..." />
                                <h4 v-else>{{course.category !== '' ? course.category : 'No category selected'}}</h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex justify-content-between align-items-center mt-3">
                                    <label class="mt-1 mr-2">Author</label>
                                    <select v-if="editEnabled" v-model="course.authorId" class="w-25 ml-2">
                                        <option value="null" selected disabled hidden>None</option>
                                        <option v-for="user in authors" :value="user.id">{{ user.id }} - {{ user.firstName }} {{ user.lastName }}</option>
                                    </select>
                                    <h4 class="ml-2" v-else>{{ course.authorId ? authorFullName : 'No author'}}</h4>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <label>Course Description - Short</label>
                                <textarea v-if="editEnabled" v-model="course.descriptionShort" type="text" rows="2" maxlength="150"></textarea>
                                <p v-else>{{course.descriptionShort === '' ? 'No short description' : course.descriptionShort}}</p>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-12">
                                <label>Course Description - Long</label>
                                <div v-show="editEnabled">
                                    <div ref="editor" class="long-editor">
                                    </div>
                                </div>
                                <div v-show="!editEnabled">
                                    <p v-show="course.descriptionLong === ''">No long description</p>
                                    <p v-show="course.descriptionLong !== ''" v-html="course.descriptionLong"></p>
                                </div>
                            </div>
                        </div>
                        <div class="row m-1 mt-3">
                            <div class="col-4 ml-0 pl-0 pr-5" >
                                <label>Site</label>
                                <div class="site-select">
                                    <select v-model="course.siteId" v-if="editEnabled && userRole == 'admin'" id="admin-siteId" v-on:click="clearWarning($event)">
                                        <option v-for="site in sites" :value="site.id">{{site.name}}</option>
                                        <option selected disabled hidden :value="null">No site selected</option>
                                    </select>
                                    <h4 v-else>
                                        {{courseSiteName}}
                                    </h4>
                                </div>
                            </div>
                            <div class="col d-flex justify-content-end align-items-center">
                                <div class="pl-0" v-show="courseHasQuestions()">
                                    <label class="text-nowrap">Minimum Percentage Pass Mark</label>
                                    <input v-show="editEnabled" id="course-passmark" v-model.number="courseDetails.minimumPercentagePassMark" type="number" />
                                    <h4 v-show="!editEnabled">{{courseDetails.minimumPercentagePassMark}}</h4>
                                </div>
                                <div class="ml-4">
                                    <label>Price</label>
                                    <input v-if="editEnabled" v-model.number="course.price" type="number" />
                                    <h4 v-else>{{course.price == 0 || course.price == null ? '' : 'R' + course.price}}</h4>
                                </div>
                                <div class="ml-4">
                                    <label>Price (USD)</label>
                                    <input v-if="editEnabled" v-model.number="course.priceUsd" type="number" />
                                    <h4 v-else>{{course.priceUsd !== 0 && course.priceUsd !== null ? '$' + course.priceUsd : course.price === 0 ? '' : 'None'}}</h4>
                                </div>
                                <div class="ml-4">
                                    <label>Sort Order</label>
                                    <input v-if="editEnabled" v-model.number="course.sortOrder" type="number" />
                                    <h4 v-else>{{course.sortOrder ? course.sortOrder : 'Default' }}</h4>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Quill from 'quill';

    export default {
        name: 'CourseInfo',
        props: ["initialCourse", "initialCourseDetails", "edit", "tab", "initialSites", "initialAuthors"],
        data: function () {
            return {
                course: this.initialCourse,
                courseDetails: this.initialCourseDetails,
                sites: this.initialSites,
                editEnabled: this.edit,
                selectedTab: this.tab,
                authors: this.initialAuthors,
                editor: null
            };
        },
        computed: {
            userRole() {
                var user = this.$store.getters.getUser;

                if (user) {
                    var roles = user.roles;
                    return roles[0];
                }
            },
            user() {
                return this.$store.getters.getUser;
            },
            courseSiteName() {
              
                if (this.sites !== undefined) {
                    for (var i = 0; i < this.sites.length; i++) {
                        var currentSite = this.sites[i];
                        if (currentSite.id == this.course.siteId) {
                            return currentSite.name;
                        }
                    }
                }
                else {
                    return "No site";
                }
            },
            authorFullName() {
                for (var i = 0; i < this.authors.length; i++) {
                    var current = this.authors[i];
                    if (current.id == this.course.authorId) {
                        var name = current.firstName + " " + current.lastName;
                        return name;
                    }
                }
            }
        },
        watch: {
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
                if (newVal == true) {
                    var delta = this.editor.clipboard.convert(this.course.descriptionLong);
                    this.editor.setContents(delta);

                    //enable editing quill and show toolbar
                    $(".ql-editor").attr("contenteditable", true);
                    $(".long-editor").removeClass("bd-none")
                    $(".ql-toolbar").show();
                }
                else {

                    //disable editing quill and hide toolbar
                    $(".ql-toolbar").hide();
                    $(".long-editor").addClass("bd-none")
                    $(".ql-editor").attr("contenteditable", false);
                }
            },
            initialAuthors: function (newVal, oldVal) {
                this.authors = newVal;
            },
            tab: function (newVal, oldVal) {
                this.selectedTab = newVal;
            },
            initialSites: function (newVal, oldVal) {
                this.sites = newVal;
            },
            initialCourse: function (newVal, oldVal) {
                this.course = newVal;
            },
            initialCourseDetails: function (newVal, oldVal) {
                this.courseDetails = newVal;
            }


        },
        methods: {
            handleToggleEdit() {
                this.$emit("toggleEdit");
            },
            initializeQuill() {
                this.editor = new Quill(this.$refs.editor, {
                    theme: 'snow',
                    placeholder: "Enter description here...",
                });

                var delta = this.editor.clipboard.convert(this.course.descriptionLong);
                this.editor.setContents(delta);

                if (!this.editEnabled) {
                    $(".ql-editor").attr("contenteditable", false);
                    $(".long-editor").addClass("bd-none");
                    $(".ql-toolbar").hide();
                }


                this.editor.on('text-change', () => {
                    this.updateDescription();
                });
            },
            updateDescription() {
                //on text change update long description
                var value = this.editor.root.innerHTML;
                this.course.descriptionLong = value;
            },
            clearWarning(event) {
                $(event.target).removeClass("bdRed");
            },
            clicked(tabIndex, page, chapter) {
                this.selectedTab = tabIndex;
                this.$emit("tabClick", tabIndex, page, chapter);
            },
            courseHasQuestions() {
                //check if course has any chapters with pages with questions
                var hasPagesWithQuestions = false;
                var courseDetails = this.courseDetails;


                for (var i = 0; i < courseDetails.chapters.length; i++) {
                    var chapter = courseDetails.chapters[i];
                    if (hasPagesWithQuestions === true) {
                        break;
                    }
                    for (var j = 0; j < chapter.pages.length; j++) {
                        var page = chapter.pages[j];
                        if (hasPagesWithQuestions === true) {
                            break;
                        }
                        for (var k = 0; k < page.components.length; k++) {
                            var component = page.components[k];
                            if (component.type == "scorm" || component.type === "question") {
                                hasPagesWithQuestions = true;
                                break;
                            }
                        }
                    }

                }
                return hasPagesWithQuestions;
            },
        },
        mounted: function () { 
            this.initializeQuill();

        },
        created() {
            if (!this.course.hasOwnProperty("siteId")) {
                var user = this.$store.getters.getUser;
                if (user.siteId) {
                    this.course.siteId = user.siteId;
                }
            }
        }
    }
</script>

<style scoped>
    .bd-none {
        border: none !important;
    }
</style>
